export default "__VITE_ASSET__00d79365__"